<div class="input-group">
  <label class="input-label" [class.label-normal]="labelStyle === 'normal'" *ngIf="label">{{ label }}</label>

  <div class="input-wrapper" *ngIf="type !== 'textarea'">
    <input
      [type]="inputType"
      [placeholder]="placeholder"
      [value]="value"
      (input)="onInput($any($event.target).value)"
      class="input-field"
      [class.input-error]="errorMessage"
    />
    <button
      *ngIf="type === 'password'"
      type="button"
      class="eye-toggle"
      (click)="togglePassword()"
    >
      <svg *ngIf="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
        <circle cx="12" cy="12" r="3"/>
      </svg>
      <svg *ngIf="showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2">
        <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.5 18.5 0 0 1 5.06-5.94M9.9 4.24A10.9 10.9 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
        <line x1="1" y1="1" x2="23" y2="23"/>
      </svg>
    </button>
  </div>

  <textarea
    *ngIf="type === 'textarea'"
    [placeholder]="placeholder"
    [value]="value"
    (input)="onInput($any($event.target).value)"
    [rows]="rows"
    class="input-textarea"
    [class.input-error]="errorMessage"
  ></textarea>

  <span *ngIf="maxLength && type === 'textarea'" class="char-count">{{ value.length }}/{{ maxLength }}</span>
  <span *ngIf="errorMessage" class="error-text">{{ errorMessage }}</span>
</div>